import { FuelButton, FuelIcon, FuelTypography } from '@frete.com/fuel-react';
import AppContext from 'context';
import { useAmplitude } from 'hooks/useAmplitude';
import { useTracking } from 'hooks/useTracking';
import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { FuelFlex } from '@frete.com/fuel-station-react';
import { dsTheme } from 'constants/styled.contants';
import { inviteDriverMessage } from '../constants';

export const benefits = [
  'Acesso a perfis completos e verificados',
  'Garantia contra golpe de adiantamento',
  'Anunciar frete para vários motoristas próximos da carga ou indo para o destino',
  'Visualização do status da viagem em tempo real',
  'Avaliação completa do motorista após viagem',
];

const SearchEmptyResult = () => {
  const {
    state: {
      searchTruckers: { term },
    },
    dispatch,
  } = useContext(AppContext);
  const { sendAmplitude } = useAmplitude();
  const { sendTracking } = useTracking();
  const { freightId } = useParams();

  const handleInviteDriver = () => {
    sendAmplitude('trucker_listing_invitation_sent', {
      source: 'convidar-motorista',
      type: 'nao-disponivel',
      freightCode: freightId,
      value: term,
    });
    sendTracking({
      event: {
        name: 'trucker_listing_invitation_sent',
      },
      data: {
        source: 'convidar-motorista',
        type: 'nao-disponivel',
        freightId: `hashed|${freightId}`,
        value: term,
      },
    });

    window.open(encodeURI(`https://api.whatsapp.com/send?text=${inviteDriverMessage}`), '_blank');
  };

  const handleGoBackToTruckersList = () => {
    dispatch({ type: 'search_truckers_clear' });
  };

  return (
    <FuelFlex
      defaultProps={{
        backgroundColor: `${dsTheme.color.background.neutral.weak}`,
        height: '100vh',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      <FuelTypography size="heading-md" weight="bold" color="neutral-strong" spacingBottom={16}>
        Convide o motorista para se cadastrar na Fretebras!
      </FuelTypography>
      <FuelTypography size="body-sm" weight="bold" color="neutral-default" spacingBottom={40}>
        Ao realizar transações com motoristas cadastrados, você tem acesso a benefícios.
      </FuelTypography>

      <FuelFlex defaultProps={{ flexDirection: 'column', gap: 'km10' }}>
        <FuelFlex
          defaultProps={{
            backgroundColor: `${dsTheme.color.background.neutral.default}`,
            padding: 'km6',
            borderRadius: 'large',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'center',
          }}
        >
          <FuelFlex
            defaultProps={{
              backgroundColor: `${dsTheme.color.background.neutral.weak}`,
              padding: 'km4',
              width: 'fit-content',
              height: 'fit-content',
              borderRadius: 'circle',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <FuelIcon size="medium" name="diamond" />
          </FuelFlex>
          <FuelTypography size="body-md" weight="bold" color="neutral-strong" spacingTop={8}>
            Benefícios disponíveis:
          </FuelTypography>
          {benefits.map((benefit) => (
            <FuelFlex
              defaultProps={{
                alignItems: 'center',
                justifyContent: 'flex-start',
                flexDirection: 'row',
                customMargin: `${dsTheme.spacing.km4} 0 0 0`,
              }}
              key={benefit}
            >
              <FuelIcon size="micro" name="one-check" iconStyle="filled" />
              <FuelTypography size="body-sm" weight="regular" color="neutral-default" spacingLeft={16}>
                {benefit}
              </FuelTypography>
            </FuelFlex>
          ))}
        </FuelFlex>
        <FuelFlex defaultProps={{ alignItems: 'center', flexDirection: 'row', justifyContent: 'center', gap: 'km12' }}>
          <FuelButton variant="tertiary" size="large" onClick={handleGoBackToTruckersList}>
            Ir para lista de motoristas
          </FuelButton>
          <FuelButton variant="whatsapp" size="large" onClick={handleInviteDriver}>
            Convidar motorista
          </FuelButton>
        </FuelFlex>
      </FuelFlex>
    </FuelFlex>
  );
};

export default SearchEmptyResult;
